import { Injectable } from '@angular/core';
import {
  EventHistoryApiModel,
  EventHistoryVersion,
  EventsData,
  EventsHistoryQueryParams,
  GetResponse,
} from '@vi-iot/client';
import { MockedEventList } from '@vi-iot/client/apis/events-history/events-history.mocks';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventsHistoryMockApi implements EventHistoryApiModel {
  getEvents(
    _installationId: string,
    params: EventsHistoryQueryParams,
    _version: EventHistoryVersion = 'v2'
  ): Observable<EventsData> {
    return of(new MockedEventList().mock(params));
  }

  triggerEventLogFileGeneration(_installationId: number): Observable<GetResponse<string>> {
    return of(null);
  }
  downloadEventLogFile(_installationId: number, _processId: string): Observable<{ data: string }> {
    return of(null);
  }
}
